import { Pressable, StyleProp, StyleSheet, View, Text, ViewStyle } from "react-native";
import { CheckSquare, ExternalLink, Square } from "lucide-react";
import { useState } from "react";

export interface TaskChipProps {
  name: string;
  category: string;
  duedate?: string | Date | number;
  isDone: boolean;
  style?: StyleProp<ViewStyle>;
  navigateToDetail?: () => void;
}

export const TaskChip = ({ name, category, duedate, isDone = false, style, navigateToDetail }: TaskChipProps) => {
  const [isHover, setIsHover] = useState(false);
  const combinedStyles = [styles.taskChip, ...(style ? [style] : []), ...(isHover ? [styles.hovered] : [])];
  return (
    <Pressable
      style={combinedStyles}
      onPress={navigateToDetail}
      onMouseEnter={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        setIsHover(false);
      }}>
      <View style={styles.taskStatus}>
        {isDone ? (
          <CheckSquare size={20} style={styles.doneStatusIcon} />
        ) : (
          <Square size={20} style={styles.undoneStatusIcon} />
        )}
      </View>
      <View style={styles.taskContent}>
        <Text style={styles.taskName}>{name}</Text>
        <View style={styles.taskMetaData}>
          <Text style={styles.metaTextStyle}>{category}</Text>
          {duedate != null && (
            <>
              <Text style={styles.metaTextStyle}>•</Text>
              <Text
                style={
                  styles.metaTextStyle
                }>{`Due ${new Date(duedate).toLocaleDateString(undefined, { weekday: "long", month: "short", day: "2-digit" })}`}</Text>
            </>
          )}
        </View>
        {navigateToDetail != null && <Text style={styles.navigateText}>Click to view in To-dos →</Text>}
      </View>
      {isHover && <ExternalLink size={16} style={styles.externalLinkIcon} />}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  taskChip: {
    position: "relative",
    width: "fit-content",
    padding: 16,
    borderRadius: 32,
    display: "flex",
    flexDirection: "row",
    gap: 12,
    borderWidth: 2,
    borderColor: "#9aaffe",
    backgroundColor: "#e6ebff",
  },
  hovered: {
    backgroundColor: "#ccd7ff",
  },
  taskStatus: {
    alignSelf: "flex-start",
    padding: 10,
    borderRadius: 16,
    backgroundColor: "#3e68fe",
  },
  doneStatusIcon: {
    color: "#fff",
  },
  undoneStatusIcon: {
    color: "#fff",
  },
  taskContent: {
    flex: 1,
    maxWidth: 360,
    paddingRight: 30,
  },
  taskName: {
    color: "#101828",
    fontWeight: 600,
    fontSize: 14,
  },
  taskMetaData: { display: "flex", flexDirection: "row", gap: 8, marginTop: 8 },
  metaTextStyle: { fontSize: 12, color: "#475467" },
  navigateText: {
    marginTop: 8,
    color: "#3e68fe",
    fontWeight: 500,
    fontSize: 12,
  },
  externalLinkIcon: {
    position: "absolute",
    top: 16,
    right: 16,
    padding: 4,
    color: "#3e68fe",
  },
});
